export class ClassCookie {
	public get = (name: string) => {
		if (document && document.cookie)
			return document.cookie
				?.split(';')
				?.find((el) => el?.includes(name))
				?.trim()
				?.slice(name.length + 1)
	}

	public set = (name: string, value: string, options = {}) => {
		let updatedCookie = `${name}=${value}`
		const optionsEntries = Object.entries(options)
		if (optionsEntries.length)
			optionsEntries.forEach(([key, value]) => {
				updatedCookie += `;${key}=${value ?? ''}`
			})
		document.cookie = updatedCookie
	}

	public delete = (name: string) => {
		this.set(name, '', { 'max-age': -1 })
	}
}
export const Cookie = new ClassCookie()
